import React, { useEffect, useState, useRef } from 'react';
import { connect, history } from 'umi';
import { isEmpty } from 'lodash';

import { Form } from 'antd';
import useGCPI18n from '@/hooks/useGCPI18n';
import Header from '@/components/Header';
import BasicBaseSpin from '@/components/BasicBaseSpin';
import { Clickable } from '@/components';
import { getDateAndDescription } from '@/utils/utils';
import { C2C_FONT_FAMILY } from '@/utils/constants';
import giftPng from '@/assets/images/postPaidC2C/gift.png';
import { RewardClaimDialogs } from '../components/RewardClaimDialog';
import useRewardClaimFlow from '../hooks/useRewardClaimFlow';
import useRewardClaimOptions from '../hooks/useRewardClaimOptions';

import styles from './index.less';
import { onHistoryPush } from '../../../utils/utils';

const MyReward = props => {
  const GCPI18n = useGCPI18n();
  const [form] = Form.useForm();
  const { activityDetail = {}, loading, isManual, gameCode, pageRenderDetail, dispatch } = props;
  const [qryType, setQryType] = useState('');
  // const [pageNum, setPageNum] = useState(1);
  const [listTotal, setListTotal] = useState(0);
  const [myAwardsList, setRewardList] = useState([]);
  const containerRef = useRef(null);

  // const { promotionId } = JSON.parse(localStorage.getItem('promotionId')) || {};
  const { mainColor, auxiliaryColor } = pageRenderDetail || {};
  const { chooseSubNumMethod, subNumType, promotionId } = activityDetail || {};
  const allEmptyImage = activityDetail?.serverUrl + pageRenderDetail?.myRewardEmptyStateImage;
  const pageFontFamily = C2C_FONT_FAMILY?.[pageRenderDetail?.fontFamily];
  const { phoneRegex, serviceNumberList } = useRewardClaimOptions({
    dispatch,
    chooseSubNumMethod,
    subNumType,
  });
  const StateTabsOptions = [
    {
      value: '',
      label: GCPI18n('lb_point_my_voucher_all'),
    },
    {
      value: 'A',
      label: GCPI18n('lb_mian_reward_unclaimed'),
    },
    {
      value: 'B',
      label: GCPI18n('lb_point_my_voucher_claimed'),
    },
  ];

  const selectedStyle = {
    border: `1px solid ${
      activityDetail.templateCode === 'ReferAndEarnTemplate' ? auxiliaryColor : mainColor
    }`,
    background: activityDetail.templateCode === 'ReferAndEarnTemplate' ? auxiliaryColor : mainColor,
    color: '#fff',
  };

  // const qryMyAchieveRewards = () => {
  //   dispatch({
  //     type: 'myAwards/getMyAchieveRewards',
  //     payload: {
  //       mobileNumber: (initApp.prefix || '86') + (initApp.phone || initApp.mobile),
  //       userId: initApp.userId || '',
  //       subsId: initApp.subsId || '',
  //       custId: initApp.custId || '',
  //       promotionId: activityDetail.promotionId || promotionId,
  //       // luckyDrawType: activityDetail.luckyDrawType, // 游戏类型
  //       product,
  //       userDimension,
  //       // luckyDrawType: LUCKY_DRAW_TYPE.ROULETTLE_LOTTERY, // 游戏类型
  //     },
  //   });
  // };

  const handleListQry = async param => {
    const res = await dispatch({
      type: 'postPaidC2c/getMyAchieveRewardsDXP',
      payload: {
        gameCode,
        state: param?.state || '',
      },
    });
    const { pageInfo = {}, data: list } = res || {};
    if (!listTotal || listTotal !== pageInfo?.total) {
      setListTotal(pageInfo?.total || 0);
    }
    if (pageInfo?.currentPage > 1) {
      setRewardList([...(myAwardsList || []), ...(list || [])]);
    } else {
      setRewardList(list);
    }
  };

  const handleTabChange = value => {
    setQryType(value);
    // setPageNum(1);
    handleListQry({
      state: value || '',
      // pageNum: 1,
    });
  };

  // const handlePageNumChange = () => {
  //   setPageNum(pageNum + 1);
  //   handleListQry({
  //     pageNum: pageNum + 1,
  //     state: stateRef.current,
  //   });
  // };

  const claimFlow = useRewardClaimFlow({
    form,
    dispatch,
    chooseSubNumMethod,
    pageRenderDetail,
    refreshAfterClaim: () => {
      handleListQry({});
    },
  });

  // gaia无需该需求
  // const handleValuesChange = changedValues => {
  //   const fieldName = Object.keys(changedValues)[0];
  //   const value = changedValues[fieldName];

  //   if (fieldName === 'ditoNumber' && !(new RegExp(/^\d*$/).test(value))) {
  //     // 如果输入不符合要求，则不更新表单值
  //     form.setFieldsValue({ [fieldName]: value.replace(/\D/g, '') });
  //   }
  // };

  useEffect(() => {
    // 查询列表
    if (promotionId) {
      handleListQry();
    }
  }, [promotionId]);

  // const handleScroll = () => {
  //   if (rewardListRef.current.length === listTotalRef.current) {
  //     return;
  //   }
  //   const container = containerRef.current;
  //   if ((container.scrollTop + container.clientHeight) > (container.scrollHeight - 40)) {
  //     handlePageNumChange();
  //   }
  // };

  const renderEmptyState = message => (
    <div className={styles.noData}>
      <img src={pageRenderDetail?.myRewardEmptyStateImage ? allEmptyImage : giftPng} alt="" />
      <div className={styles.tip}>{message}</div>
    </div>
  );

  const renderAllTip = () =>
    myAwardsList.length === listTotal && (
      // eslint-disable-next-line react/no-unescaped-entities
      <div className={styles.allTip}>{GCPI18n('lb_post_paid_keep_tips')}</div>
    );

  const renderRewardCard = (reward, index, renderStateAction) => {
    const { rewardName, serverUrl, imageUrl } = reward || {};
    const rewardImgUrl = `${serverUrl}${imageUrl}`;
    return (
      <div className={styles.rewardInfo} key={`${rewardName}_${index}`}>
        <div className={styles.left}>
          <img src={rewardImgUrl || giftPng} alt="" />
        </div>
        <div className={styles.right}>
          <div className={styles.infoBox}>
            <div
              className={styles.name}
              style={{
                color: pageRenderDetail?.rewardNameColor,
              }}
            >
              {rewardName}
            </div>
            <div className={styles.before}>{getDateAndDescription(reward).description}</div>
            <div className={styles.receiveDeadDate}>{getDateAndDescription(reward).date}</div>
          </div>
          <div className={styles.stateBox}>{renderStateAction(reward)}</div>
        </div>
      </div>
    );
  };

  const renderRewardList = renderStateAction => (
    <div className={styles.rewardList}>
      {myAwardsList.map((reward, index) => renderRewardCard(reward, index, renderStateAction))}
      {renderAllTip()}
    </div>
  );

  const renderViewAction = reward => {
    const { keyId, rewardMemId } = reward || {};
    return (
      <Clickable
        className={styles.view}
        onClick={() => {
          onHistoryPush(
            '/NewRewardDetail',
            {
              keyId,
              promotionId,
              rewardMemId,
            },
            {
              title: GCPI18n('lb_reward_details'),
              specialTimeType: true,
              fontFamily: pageFontFamily,
            },
          );
        }}
        style={{ color: auxiliaryColor }}
      >
        {GCPI18n('btn_common_view')}
      </Clickable>
    );
  };

  const renderClaimAction = reward => {
    const { state } = reward || {};
    return (
      <>
        {state === 'A' && (
          <Clickable
            className={styles.claim}
            style={{ background: mainColor }}
            onClick={() => claimFlow.handleClaimReward(reward)}
          >
            {pageRenderDetail?.claimRewardButtonText}
          </Clickable>
        )}
        {state === 'B' && <div className={styles.claimed}>{GCPI18n('lb_post_paid_claimed')}</div>}
        {state === 'E' && <div className={styles.expired}>{GCPI18n('lb_post_paid_expired')}</div>}
      </>
    );
  };

  const getManualEmptyMessage = () => {
    if (qryType === 'A') {
      return GCPI18n('lb_my_reward_empty_state_a_message');
    }
    if (qryType === 'B') {
      return GCPI18n('lb_my_reward_empty_state_b_message');
    }
    return pageRenderDetail?.myRewardEmptyStateMessage;
  };

  return (
    <div className={styles.pageWrap} style={{ fontFamily: pageFontFamily }}>
      <BasicBaseSpin spinning={loading} size="large">
        <Header
          title={GCPI18n('lb_my_awards_task')}
          titleColor="#3E3E3E"
          titleFontFamily={pageFontFamily}
          goBack={() => history.goBack()}
          hideGoHome
        />
        {isManual === 'N' || (myAwardsList?.[0] && !myAwardsList?.[0]?.isManualClaim) ? (
          <div className={styles.contain}>
            <div className={styles.listBox} ref={containerRef}>
              {isEmpty(myAwardsList)
                ? renderEmptyState(pageRenderDetail?.myRewardEmptyStateMessage)
                : renderRewardList(renderViewAction)}
            </div>
          </div>
        ) : (
          <div className={styles.contain}>
            <div className={styles.listBox} ref={containerRef}>
              <div className={styles.stateTabs}>
                {StateTabsOptions.map(it => (
                  <Clickable
                    key={it.label}
                    className={styles.tab}
                    onClick={() => handleTabChange(it.value)}
                    style={qryType === it.value ? selectedStyle : {}}
                  >
                    {it.label}
                  </Clickable>
                ))}
              </div>
              {isEmpty(myAwardsList)
                ? renderEmptyState(getManualEmptyMessage())
                : renderRewardList(renderClaimAction)}
            </div>
          </div>
        )}
      </BasicBaseSpin>
      <RewardClaimDialogs
        claimFlow={claimFlow}
        styles={styles}
        form={form}
        pageFontFamily={pageFontFamily}
        pageRenderDetail={pageRenderDetail}
        chooseSubNumMethod={chooseSubNumMethod}
        serviceNumberList={serviceNumberList}
        phoneRegex={phoneRegex}
        mainColor={mainColor}
        GCPI18n={GCPI18n}
      />
    </div>
  );
};

export default connect(({ index, myAwards, loading }) => ({
  pageRenderDetail: index.pageRenderDetail,
  isManual: index.isManual,
  activityDetail: index.activityDetail,
  gameCode: index.gameCode,
  myAwardsList: myAwards.myAwardsList,
  loading:
    loading.effects['postPaidC2c/getMyAchieveRewardsDXP'] ||
    loading.effects['myAwards/claimRewardDXP'] ||
    false,
}))(MyReward);
